(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // City switcher (Dallas / San Antonio consolidation).
    // Choice persists in localStorage; crawlers and no-JS visitors see the
    // full catalog (filtering is progressive enhancement only).
    var hdr = document.querySelector('.shag-header') || { dataset: {} };
    var CITY = {
      'dallas':      { label: 'Dallas',      phone: hdr.dataset.dallasPhone || '214-742-5252', quote: 'Dallas' },
      'san-antonio': { label: 'San Antonio', phone: hdr.dataset.saPhone || '210-900-4800', quote: 'San Antonio' }
    };
    function getCity() { try { return localStorage.getItem('shag_city'); } catch (e) { return null; } }
    function storeCity(c) { try { localStorage.setItem('shag_city', c); } catch (e) {} }

    var picker = document.getElementById('shag-citypick');
    var overlay = document.getElementById('shag-citypick-overlay');
    var chip = document.getElementById('shag-city-chip');
    var chipLabel = document.getElementById('shag-city-chip-label');

    function openPicker() { if (picker) { picker.hidden = false; overlay.hidden = false; } }
    function closePicker() { if (picker) { picker.hidden = true; overlay.hidden = true; } }

    function applyCity(explicit) {
      var c = getCity();
      if (!c || !CITY[c]) return;
      var data = CITY[c];
      if (chipLabel) chipLabel.textContent = data.label;
      if (chip) chip.classList.toggle('is-sa', c === 'san-antonio');   // Oct 2 2026 (Christine): pink = Dallas, blue = San Antonio
      document.querySelectorAll('[data-shag-phone]').forEach(function (el) { el.textContent = data.phone; });
      document.querySelectorAll('[data-shag-phone-link]').forEach(function (el) { el.setAttribute('href', 'tel:' + data.phone); });
      document.querySelectorAll('[data-shag-city-contact]').forEach(function (el) {
        el.hidden = el.getAttribute('data-shag-city-contact') !== c;
      });
      document.querySelectorAll('a[data-city], li[data-city], img[data-city], div[data-city], span[data-city], details[data-city]').forEach(function (a) { a.style.display = (a.getAttribute('data-city') === c) ? '' : 'none'; });
      // Oct 2 2026: dropdowns / mobile groups with no link for this city are marked empty (see .is-empty in the styles)
      document.querySelectorAll('.shag-nav__dropdown, .shag-mobilenav__group').forEach(function (box) {
        var any = Array.prototype.some.call(box.querySelectorAll(box.tagName === 'DETAILS' ? 'div a' : 'a'), function (a) {
          for (var n = a; n && n !== box; n = n.parentElement) { if (n.style && n.style.display === 'none') return false; }
          return true;
        });
        box.classList.toggle('is-empty', !any);
      });
      document.querySelectorAll('.shag-tile[data-cities]').forEach(function (t) {
        t.style.display = (t.getAttribute('data-cities').indexOf(c) !== -1) ? '' : 'none';
      });
      var quoteSel = document.querySelector('select[name="contact[Shag Location]"]');
      if (quoteSel && (!quoteSel.value || explicit)) {
        quoteSel.value = data.quote;
        quoteSel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      // tagline per city (theme settings)
      document.querySelectorAll('[data-shag-tagline]').forEach(function (el) {
        var t = el.getAttribute('data-shag-tagline-' + c); if (t) el.innerHTML = t;
      });
      // search results: after city filtering a page can be empty -> say so and hide the pager
      // (SCP5-04: same rule for every product grid, search results and collections alike)
      document.querySelectorAll('.shag-search__results, .shag-category-grid__tiles').forEach(function (grid) {
        var tiles = grid.querySelectorAll('.shag-tile');
        if (!tiles.length) return;   // a collection with no products shows its own server-rendered message
        var visible = Array.prototype.filter.call(tiles, function (t) { return t.style.display !== 'none'; }).length;
        var msg = grid.querySelector('.shag-search__city-empty, .shag-category-grid__city-empty'); var pager = grid.querySelector('.shag-category-grid__pagination');
        if (msg) msg.hidden = visible > 0;
        if (pager) pager.style.display = (visible === 0) ? 'none' : pager.getAttribute('data-stitched') ? 'none' : '';
      });
      document.querySelectorAll('[data-shag-city-name]').forEach(function (el) { el.textContent = (c === 'dallas') ? 'Dallas' : 'San Antonio'; });
      document.dispatchEvent(new CustomEvent('shag:city', { detail: c }));
    }

    function cityName(c) { return c === 'dallas' ? 'Dallas' : 'San Antonio'; }
    // Sept 22 2026 (Christine/Gary): lines from the other city never stay in the rental list.
    // Remove them, reload so the count / mini-list / list page are fresh, and say so once in the banner.
    function cleanupCart(c) {
      var el = document.getElementById('shag-cart-cities'); if (!el || !c) return;
      var lines; try { lines = JSON.parse(el.textContent || '[]'); } catch (e) { return; }
      var gone = lines.filter(function (l) { return l.cities && l.cities.indexOf(c) === -1; });
      if (!gone.length) return;
      var sig = c + ':' + gone.map(function (l) { return l.key; }).join(',');
      try { if (sessionStorage.getItem('shag_cart_cleanup') === sig) return; sessionStorage.setItem('shag_cart_cleanup', sig); } catch (e) {}   // one attempt per set of lines: no reload loops
      var updates = {}; gone.forEach(function (l) { updates[l.key] = 0; });
      fetch(el.getAttribute('data-update-url') || '/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function () {
          try { sessionStorage.setItem('shag_cart_removed', JSON.stringify({ city: c, titles: gone.map(function (l) { return l.title; }) })); } catch (e) {}
          window.location.reload();
        })
        .catch(function () {});   // if the cart call fails, the rental list page still flags the lines and the quote form still refuses them
    }
    function showRemovedBanner() {
      var raw = null; try { raw = sessionStorage.getItem('shag_cart_removed'); sessionStorage.removeItem('shag_cart_removed'); } catch (e) {}
      if (!raw) return; var info; try { info = JSON.parse(raw); } catch (e) { return; }
      var box = document.getElementById('shag-city-banner'); if (!box || !info.titles || !info.titles.length) return;
      var n = info.titles.length; var other = cityName(info.city === 'dallas' ? 'san-antonio' : 'dallas');
      box.querySelector('[data-banner-text]').textContent = (n === 1 ? '1 item' : n + ' items') + ' rented from our ' + other + ' warehouse only ' + (n === 1 ? 'was' : 'were') + ' removed from your rental list: ' + info.titles.join(', ') + '.';
      box.hidden = false;
      var x = box.querySelector('button'); if (x) x.addEventListener('click', function () { box.hidden = true; });
    }
    function setCity(c) { storeCity(c); applyCity(true); closePicker(); cleanupCart(c); }
    window.shagSetCity = setCity;   // product page "Switch to ... inventory" button
    // Oct 2 2026: an empty mobile group (no links for this city) opens its own page instead of expanding to nothing
    document.addEventListener('click', function (e) {
      var sm = e.target.closest && e.target.closest('.shag-mobilenav__group.is-empty > summary'); if (!sm) return;
      var href = sm.parentElement.getAttribute('data-href'); if (href) { e.preventDefault(); window.location.href = href; }
    });

    if (picker) {
      picker.querySelectorAll('.shag-citypick__city').forEach(function (b) {
        b.addEventListener('click', function () { setCity(b.getAttribute('data-city')); });
      });
      var close = document.getElementById('shag-citypick-close');
      if (close) close.addEventListener('click', function () { if (!getCity()) storeCity('dallas'); applyCity(); closePicker(); });
      overlay.addEventListener('click', function () { if (!getCity()) storeCity('dallas'); applyCity(); closePicker(); });
    }
    if (chip) chip.addEventListener('click', function (e) { e.preventDefault(); openPicker(); });

    // "Browse San Antonio Inventory" (and any SA collection link) implies choosing SA.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/collections/san-antonio"]');
      if (a) { storeCity('san-antonio'); }
    });

    // Deep links can preselect a city: /?city=dallas or /?city=san-antonio (FAQ cross-links, emails, ads).
    try { var qc = new URLSearchParams(window.location.search).get('city'); if (qc === 'dallas' || qc === 'san-antonio') storeCity(qc); } catch (e) {}
    // SCP5-14: an unknown stored value (old key format, typo) must not leave the visitor unfiltered with no picker
    if (getCity() && !CITY[getCity()]) { try { localStorage.removeItem('shag_city'); } catch (e) {} }
    applyCity();
    if (!getCity()) openPicker();
    showRemovedBanner();
    cleanupCart(getCity());   // covers city changes made without the picker ("Browse San Antonio Inventory" tile, ?city= links, product-page auto-switch)
  })();


  (function () {
    // Sept 22 2026 (Christine): Shopify's online-store search is semantic - it adds items it thinks are related
    // (46 hits for "dance floor", most containing neither word). Volusion matched the typed words only.
    // Quoting each word makes Shopify match exact words with every word required. Quoted words already match
    // singular and plural ("boot" finds Boots), and OR alternatives only ever shrink results, so no OR groups.
    // snippets/shag-search-typed.liquid turns the quoted form back into the typed words for display.
    function exact(q) {
      q = (q || '').trim();
      if (!q || /^"[^"]*"( "[^"]*")*$/.test(q)) return q;   // empty, or already quoted (back button, rewritten link)
      var words = q.replace(/["()*]/g, ' ').split(/\s+/).filter(function (w) { return w && !/^(or|and|not)$/i.test(w); });
      if (!words.length) return q;
      if (words.length === 1 && /^\d{3,}$/.test(words[0])) return words[0];   // Sept 24: a product code must stay unquoted - exact-word mode does not read the SKU field
      return words.map(function (w) { return '"' + w + '"'; }).join(' ');
    }
    window.shagExactSearch = exact;
    document.addEventListener('submit', function (e) {
      var f = e.target; if (!f || !f.getAttribute || (f.getAttribute('action') || '').indexOf('/search') === -1) return;
      var q = f.querySelector('input[name="q"]'); if (q) q.value = exact(q.value);
    }, true);
    // menu / swatch fallbacks that link straight to /search?q=<category name>
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/search?q="]'); if (!a) return;
      try {
        var u = new URL(a.getAttribute('href'), window.location.href); var q = u.searchParams.get('q');
        if (u.origin !== window.location.origin) return;   // Oct 2 2026: never touch outside links (the Google reviews logo is google.com/search?q=...)
        if (q && !/^"/.test(q)) {
          u.searchParams.set('q', exact(q));
          if (!u.searchParams.get('type')) u.searchParams.set('type', 'product');
          if (!u.searchParams.get('sort_by')) u.searchParams.set('sort_by', 'price-descending');
          a.setAttribute('href', u.pathname + u.search);
        }
      } catch (err) {}
    }, true);
  })();

  (function () {
    // Mobile slide-in menu (live scarpetRes push-menu behavior).
    var burger = document.getElementById('shag-burger');
    var panel = document.getElementById('shag-mobilenav');
    var overlay = document.getElementById('shag-mobilenav-overlay');
    var closeBtn = document.getElementById('shag-mobilenav-close');
    function openMenu() {
      panel.hidden = false;
      overlay.hidden = false;
      void panel.offsetWidth; // force reflow so the slide-in transition runs
      panel.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      panel.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () { panel.hidden = true; overlay.hidden = true; }, 250);
    }
    if (burger && panel && overlay) {
      burger.addEventListener('click', openMenu);
      overlay.addEventListener('click', closeMenu);
      if (closeBtn) closeBtn.addEventListener('click', closeMenu);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) closeMenu(); });
    }
  })();

  (function () {
    // Slide-out header search, like the live site's expanding search box.
    var toggle = document.getElementById('shag-searchtoggle');
    var form = document.getElementById('shag-headersearch');
    if (toggle && form) {
      toggle.addEventListener('click', function () {
        form.classList.toggle('is-open');
        if (form.classList.contains('is-open')) {
          form.querySelector('input').focus();
        }
      });
    }

    // Mini-cart: the X dismisses it until the next hover session,
    // matching the live site's close behavior.
    var mini = document.getElementById('shag-minicart');
    var close = document.getElementById('shag-minicart-close');
    var wrap = document.getElementById('shag-wishlist-wrap');
    if (mini && close && wrap) {
      close.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        mini.classList.add('is-dismissed');
      });
      wrap.addEventListener('mouseleave', function () {
        mini.classList.remove('is-dismissed');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  // Search: pull pages 2..N into page 1 so every result sits on one page (Volusion parity).
  // Shopify hard-caps search.results per page, so the section paginates by 50 and we stitch.
  (function () {
    var grid = document.querySelector('.shag-search__server .shag-search__results');
    if (!grid) return;
    if (document.querySelector('.shag-search.is-vs, .shag-search.is-vs-pending')) return;   // Oct 2 2026: Volusion-style results in use
    // Price sort: break ties alphabetically (same rule as the category grid, Sept 22 2026).
    function sortTies() {
      var sortBy = '';
      try { sortBy = new URL(window.location.href).searchParams.get('sort_by') || ''; } catch (e) {}
      if (sortBy.indexOf('price') !== 0) return;
      var tiles = Array.prototype.slice.call(grid.querySelectorAll(':scope > .shag-tile'));
      if (tiles.length < 2) return;
      var price = function (t) { var a = t.querySelector('.shag-tile__amount'); return a ? parseFloat(a.textContent.replace(/[^0-9.]/g, '')) : NaN; };
      var name = function (t) { var n = t.querySelector('.shag-tile__name'); return n ? n.textContent.trim() : ''; };
      var i = 0;
      while (i < tiles.length) {
        var j = i + 1;
        while (j < tiles.length && price(tiles[j]) === price(tiles[i])) j++;
        if (j - i > 1) {
          var run = tiles.slice(i, j);
          var anchor = tiles[j] || run[run.length - 1].nextSibling;
          var sorted = run.slice().sort(function (a, b) { return name(a).localeCompare(name(b), undefined, { numeric: true, sensitivity: 'base' }); });
          var changed = sorted.some(function (n, k) { return n !== run[k]; });
          if (changed) sorted.forEach(function (n) { grid.insertBefore(n, anchor); });
        }
        i = j;
      }
    }
    var pager = grid.querySelector('.shag-category-grid__pagination');
    if (!pager) { sortTies(); return; }
    var pages = parseInt(pager.getAttribute('data-pages') || '1', 10);
    var current = parseInt(pager.getAttribute('data-page') || '1', 10);
    if (pages <= 1 || current !== 1) { sortTies(); return; } // deep links to ?page=N keep ordinary paging
    var status = grid.querySelector('.shag-search__loading');
    var emptyMsg = grid.querySelector('.shag-search__city-empty');
    pager.style.display = 'none';
    if (status) status.hidden = false;

    function currentCity() {
      try { return localStorage.getItem('shag_city') || 'dallas'; } catch (e) { return 'dallas'; }
    }
    function applyCity() {
      var c = currentCity();
      grid.querySelectorAll('.shag-tile[data-cities]').forEach(function (t) {
        t.style.display = (t.getAttribute('data-cities').indexOf(c) !== -1) ? '' : 'none';
      });
      var visible = Array.prototype.filter.call(grid.querySelectorAll('.shag-tile'), function (t) { return t.style.display !== 'none'; }).length;
      if (emptyMsg) emptyMsg.hidden = visible > 0;
    }
    function pageUrl(n) {
      var u = new URL(window.location.href);
      u.searchParams.set('page', String(n));
      return u.toString();
    }
    var n = 2;
    function next() {
      if (n > pages) { if (status) status.hidden = true; sortTies(); applyCity(); return; }
      fetch(pageUrl(n), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var tiles = doc.querySelectorAll('.shag-search__results .shag-tile');
          var frag = document.createDocumentFragment();
          // SCP5-13: never show the same product twice if the result set shifts between page fetches
          var seen = {};
          grid.querySelectorAll('.shag-tile a[href]').forEach(function (a) { seen[a.getAttribute('href').split('?')[0]] = true; });
          tiles.forEach(function (t) {
            var a = t.querySelector('a[href]'); var key = a ? a.getAttribute('href').split('?')[0] : null;
            if (key && seen[key]) return;
            if (key) seen[key] = true;
            frag.appendChild(document.importNode(t, true));
          });
          pager.setAttribute('data-stitched', '1');
          if (emptyMsg) grid.insertBefore(frag, emptyMsg); else grid.appendChild(frag);
          applyCity();
          n++;
          next();
        })
        .catch(function () {
          // fall back to ordinary paging for whatever did not load
          pager.style.display = '';
          if (status) status.hidden = true;
        });
    }
    next();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shag-articles-forwarder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var box = document.getElementById('shag-forwarder'); if (!box) return;
    var q = window.location.search.replace(/^\?/, '').split('&');
    var id = null;
    q.forEach(function (kv) { var p = kv.split('='); if (p[0].toLowerCase() === 'id') id = decodeURIComponent(p[1] || ''); });
    var target = null;
    if (id) {
      var li = box.querySelector('li[data-article-id="' + id.replace(/"/g, '') + '"]');
      if (li) target = li.getAttribute('data-target');
    }
    if (!target && /help\.php|help\.asp|faq/i.test(document.referrer + window.location.href)) target = '/pages/faq';
    if (target) { window.location.replace(target); }
    else if (id) { window.location.replace(box.getAttribute('data-fallback') || '/search'); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shag-category-grid"] && !Shopify.designMode) return;
  try {
    
  // Sept 22 2026 (Wendy via Christine): when sorting by price, break ties alphabetically so all the
  // "Madison" / "Thompson" chairs at the same price sit together. Shopify collections have no secondary
  // sort key, so runs of equal-price tiles are re-ordered here; membership and paging are untouched.
  (function () {
    function sortTies(grid) {
      var tiles = Array.prototype.slice.call(grid.querySelectorAll(':scope > .shag-tile'));
      if (tiles.length < 2) return;
      var price = function (t) { var a = t.querySelector('.shag-tile__amount'); return a ? parseFloat(a.textContent.replace(/[^0-9.]/g, '')) : NaN; };
      var name = function (t) { var n = t.querySelector('.shag-tile__name'); return n ? n.textContent.trim() : ''; };
      var i = 0;
      while (i < tiles.length) {
        var j = i + 1;
        while (j < tiles.length && price(tiles[j]) === price(tiles[i])) j++;
        if (j - i > 1) {
          var run = tiles.slice(i, j);
          var anchor = tiles[j] || run[run.length - 1].nextSibling;
          var sorted = run.slice().sort(function (a, b) { return name(a).localeCompare(name(b), undefined, { numeric: true, sensitivity: 'base' }); });
          var changed = sorted.some(function (n, k) { return n !== run[k]; });
          if (changed) sorted.forEach(function (n) { grid.insertBefore(n, anchor); });
        }
        i = j;
      }
    }
    window.shagSortTies = sortTies;
    document.querySelectorAll('.shag-category-grid__tiles[data-sort^="price"]').forEach(sortTies);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shag-faq"] && !Shopify.designMode) return;
  try {
    
  // Rich-text settings cannot carry target attributes: open off-site FAQ links (Game On, catalog) in a new tab.
  document.querySelectorAll('.shag-faq-page a[href^="http"]').forEach(function (a) {
    if (a.host && a.host !== window.location.host) { a.target = '_blank'; a.rel = 'noopener'; }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shag-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.shag-hero').forEach(function (hero) {
    var allSlides = Array.prototype.slice.call(hero.querySelectorAll('.shag-hero__slide'));
    function cityOf() { try { return localStorage.getItem('shag_city') || 'dallas'; } catch (e) { return 'dallas'; } }
    function forCity() {
      var c = cityOf();
      var list = allSlides.filter(function (s) { var sc = s.getAttribute('data-slide-city') || 'both'; return sc === 'both' || sc === c; });
      return list.length ? list : allSlides;
    }
    var slides = forCity();
    allSlides.forEach(function (s) { s.hidden = slides.indexOf(s) === -1; });
    document.addEventListener('shag:city', function () { location.reload(); });
    var allDots = Array.prototype.slice.call(hero.querySelectorAll('.shag-hero__dots button'));
    allDots.forEach(function (d) { var sl = allSlides[parseInt(d.dataset.slide, 10)]; d.hidden = slides.indexOf(sl) === -1; });
    var dots = allDots.filter(function (d) { return !d.hidden; });
    var current = 0;
    var timer;

    function loadSlide(el) {
      if (!el) return;
      var im = el.querySelector('img[data-src]');
      if (im) {
        im.src = im.getAttribute('data-src');
        if (im.getAttribute('data-srcset')) im.srcset = im.getAttribute('data-srcset');
        im.removeAttribute('data-src');
        im.removeAttribute('data-srcset');
      }
    }
    function show(n) {
      current = (n + slides.length) % slides.length;
      loadSlide(slides[current]);
      loadSlide(slides[(current + 1) % slides.length]); // preload the next one
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
    }
    function auto() {
      clearInterval(timer);
      timer = setInterval(function () { show(current + 1); }, 6000);
    }
    hero.querySelector('.shag-hero__arrow--prev').addEventListener('click', function () { show(current - 1); auto(); });
    hero.querySelector('.shag-hero__arrow--next').addEventListener('click', function () { show(current + 1); auto(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(d); });
    });
    function go(d) { show(dots.indexOf(d)); auto(); }
    auto();
    if (slides.length > 1) loadSlide(slides[1]); // have the second slide ready before the first rotation
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shag-product"]) return;
  try {
    
  document.querySelectorAll('.shag-product__notes a').forEach(function (a) { a.target = '_blank'; a.rel = 'noopener'; });
  function shagApplyCityGuard() {
    var c = (function () { try { return localStorage.getItem('shag_city') || 'dallas'; } catch (e) { return 'dallas'; } })();
    // whole page: other-city product -> only the "not available" panel (the inline script did this before paint; this keeps it in sync on city switches)
    var root = document.getElementById('shag-product-root'); var rc = root ? root.getAttribute('data-cities') : null;
    if (root && rc) root.classList.toggle('is-other-city', rc.indexOf(c) === -1);
    document.querySelectorAll('.shag-product__form[data-cities]').forEach(function (f) {
      var cities = f.getAttribute('data-cities') || ''; var ok = cities.indexOf(c) !== -1 || cities.trim() === '';
      var btn = f.querySelector('button[type="submit"]');
      if (btn) btn.disabled = !ok;
    });
  }
  shagApplyCityGuard(); document.addEventListener('shag:city', shagApplyCityGuard);
  document.querySelectorAll('[data-switch-city]').forEach(function (b) {
    b.addEventListener('click', function () {
      var c = b.getAttribute('data-switch-city');
      if (window.shagSetCity) { window.shagSetCity(c); } else { try { localStorage.setItem('shag_city', c); } catch (e) {} window.location.reload(); }
    });
  });
  function shagApplyQtyCity() {
    var c = (function () { try { return localStorage.getItem('shag_city') || 'dallas'; } catch (e) { return 'dallas'; } })();
    document.querySelectorAll('input[name="quantity"][data-avail-dallas], input[name="updates[]"][data-avail-dallas]').forEach(function (inp) {
      var v = inp.getAttribute('data-avail-' + c) || inp.getAttribute('data-avail-dallas');
      if (v && parseInt(v, 10) > 0) { inp.max = v; inp.dataset.avail = v; inp.title = 'Up to ' + v + ' available'; }
    });
  }
  shagApplyQtyCity(); document.addEventListener('shag:city', shagApplyQtyCity);
  document.querySelectorAll('.shag-product').forEach(function (root) {
    var main = root.querySelector('.shag-product__main');
    var box = root.querySelector('#shag-lightbox');
    var boxImg = root.querySelector('#shag-lightbox-img');
    var pager = root.querySelector('#shag-lightbox-pager');
    var pages = pager ? Array.prototype.slice.call(pager.children) : [];

    root.querySelectorAll('.shag-product__thumbs button').forEach(function (b) {
      function swap() {
        main.removeAttribute('srcset');
        main.src = b.dataset.full;
        main.dataset.index = b.dataset.index;
      }
      b.addEventListener('mouseenter', swap);   // Volusion: onmouseover swaps the main photo
      b.addEventListener('focus', swap);
      b.addEventListener('click', function () { swap(); openBox(parseInt(b.dataset.index, 10) || 0); });   // Volusion: click opens the popup
    });

    function openBox(index) {
      if (!box) return;
      goTo(index);
      box.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closeBox() {
      box.hidden = true;
      document.body.style.overflow = '';
    }
    var current = 0;
    function goTo(index) {
      if (!pages.length) return;
      index = ((index % pages.length) + pages.length) % pages.length;   // wraps: after the last photo comes the first
      var btn = pages[index];
      boxImg.src = btn.dataset.large;
      current = index;
      pages.forEach(function (p, i) { p.classList.toggle('is-current', i === index); });
    }

    if (main) {
      main.addEventListener('click', function () { openBox(parseInt(main.dataset.index, 10) || 0); });
    }
    var larger = root.querySelector('.shag-product__larger-link');
    if (larger) {
      larger.addEventListener('click', function (e) { e.preventDefault(); openBox(parseInt(main.dataset.index, 10) || 0); });
    }
    pages.forEach(function (p) {
      p.addEventListener('click', function () { goTo(parseInt(p.dataset.index, 10)); });
    });
    if (box) {
      box.addEventListener('click', function (e) { if (e.target === box) closeBox(); });
      // Sept 28 2026 (Christine): keyboard in the photo popup - left/right arrows step through the photos, Esc closes
      document.addEventListener('keydown', function (e) {
        if (box.hidden) return;
        if (e.key === 'Escape') { closeBox(); }
        else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); goTo(current + 1); }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); goTo(current - 1); }
      });
    }

    // Volusion-style product options (Accessories inserts): radio picks the
    // variant, updates the price, swaps the photo; swatches proxy the radios.
    var radios = Array.prototype.slice.call(root.querySelectorAll('.shag-product__radios input'));
    var priceEl = root.querySelector('.shag-product__price');
    var form = root.querySelector('.shag-product__form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var swatches = Array.prototype.slice.call(root.querySelectorAll('.shag-product__swatches button'));

    function applyVariant(r) {
      if (idInput) idInput.value = r.value;
      if (priceEl && r.dataset.price) priceEl.textContent = r.dataset.price;
      if (main && r.dataset.img) { main.removeAttribute('srcset'); main.src = r.dataset.img; }
      swatches.forEach(function (s) { s.classList.toggle('is-selected', s.dataset.variant === r.value); });
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) applyVariant(r); });
    });
    swatches.forEach(function (s) {
      s.addEventListener('click', function () {
        var r = radios.filter(function (x) { return x.value === s.dataset.variant; })[0];
        if (r) { r.checked = true; applyVariant(r); }
      });
    });
    if (form && idInput && idInput.dataset.requiresOption !== undefined) {
      form.addEventListener('submit', function (e) {
        if (!idInput.value) {
          e.preventDefault();
          alert('Please select ' + (idInput.dataset.requiresOption || 'an option') + ' before adding this item to your rental list.');
        }
      });
    }
    // Quantity cap: never let a request exceed the "Potential Quantity Available" (counts what is already in the rental list)
    var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
    if (form && qtyInput && qtyInput.dataset.avail) {
      form.addEventListener('submit', function (e) {
        var avail = parseInt(qtyInput.dataset.avail, 10);
        var inCart = parseInt(qtyInput.dataset.inCart, 10) || 0;
        var want = parseInt(qtyInput.value, 10) || 0;
        if (want + inCart > avail) {
          e.preventDefault();
          var room = Math.max(avail - inCart, 0);
          alert('Only ' + avail + ' of this item ' + (avail === 1 ? 'is' : 'are') + ' available' + (inCart ? ' and ' + inCart + ' ' + (inCart === 1 ? 'is' : 'are') + ' already in your rental list' : '') + '. Please enter ' + room + ' or less.');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shag-quote-form"]) return;
  try {
    
  // Rental list must fit the selected location: no other-city items, no quantity above that city's availability.
  (function () {
    var form = document.querySelector('.shag-quote__form') || document.querySelector('form[action*="/contact"]');
    if (!form) return;
    function problems() {
      var sel = form.querySelector('select[name="contact[Shag Location]"]');
      var c = sel && /San Antonio/i.test(sel.value) ? 'san-antonio' : 'dallas';
      var out = [];
      form.querySelectorAll('.shag-quote__line').forEach(function (l) {
        var cities = l.getAttribute('data-cities') || ''; var q = parseInt(l.getAttribute('data-qty'), 10) || 0;
        var cap = parseInt(l.getAttribute('data-avail-' + c), 10) || 0;
        if (cities && cities.indexOf(c) === -1) out.push(l.getAttribute('data-title') + ' is not rented from our ' + (c === 'dallas' ? 'Dallas' : 'San Antonio') + ' warehouse. Remove it from your list or choose the other location.');
        else if (cap > 0 && q > cap) out.push(l.getAttribute('data-title') + ': only ' + cap + ' available in ' + (c === 'dallas' ? 'Dallas' : 'San Antonio') + ', your list has ' + q + '. Adjust it on the rental list page.');
      });
      return out;
    }
    function render() { var box = document.getElementById('shag-quote-problems'); if (!box) return; var p = problems(); box.hidden = p.length === 0; box.innerHTML = p.map(function (t) { return '<li>' + t + '</li>'; }).join(''); }
    var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    var hasLines = form.querySelectorAll('.shag-quote__line').length > 0;
    if (!hasLines && submitBtn) { submitBtn.disabled = true; submitBtn.title = 'Add items to your rental list first'; }   // SCP5-22: no blank quotes to sales
    form.addEventListener('submit', function (e) {
      var p = problems();
      if (p.length || !hasLines) { e.preventDefault(); render(); (document.getElementById('shag-quote-problems') || form).scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      // Oct 1 2026: notes are "contact[Additional Notes]" (e-mail label "Additional Notes"); Shopify only requires contact[email],
      // so the old SCP5-06 copy of the rental list into contact[body] is gone (it duplicated the Rental Wish List).
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending...'; }   // SCP5-22: no double submit
    });
    var sel = form.querySelector('select[name="contact[Shag Location]"]'); if (sel) sel.addEventListener('change', render);
    render();
  })();

  document.querySelectorAll('.shag-quote select').forEach(function (s) {
    s.addEventListener('change', function () {
      s.classList.toggle('is-placeholder', s.value === '');
      s.classList.toggle('has-value', s.value !== '');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shag-rental-list"]) return;
  try {
    
  // Quantity cap on Recalculate: no line may exceed the product's "Potential Quantity Available"
  function shagRentalCity() {
    var c = (function () { try { return localStorage.getItem('shag_city') || 'dallas'; } catch (e) { return 'dallas'; } })();
    var problems = [];
    document.querySelectorAll('input[name="updates[]"]').forEach(function (inp) {
      var row = inp.closest('tr'); var title = inp.dataset.title || (row && row.querySelector('.shag-rental__desc a') ? row.querySelector('.shag-rental__desc a').textContent : 'item');
      var cities = inp.getAttribute('data-cities') || '';
      if (cities && cities.indexOf(c) === -1) { problems.push(title + ' is rented from our ' + (cities.indexOf('dallas') !== -1 ? 'Dallas' : 'San Antonio') + ' warehouse only: remove it or switch city.'); if (row) row.classList.add('shag-rental__row--other-city'); }
      else if (row) row.classList.remove('shag-rental__row--other-city');
      var v = inp.getAttribute('data-avail-' + c) || inp.getAttribute('data-avail-dallas');
      if (v && parseInt(v, 10) > 0) {
        inp.max = v; inp.dataset.avail = v; inp.title = 'Up to ' + v + ' available';
        if (parseInt(inp.value, 10) > parseInt(v, 10)) { inp.value = v; problems.push(title + ': only ' + v + ' available in this city, quantity set to ' + v + '. Click Recalculate.'); if (row) row.classList.add('shag-rental__row--capped'); }
      }
    });
    var box = document.getElementById('shag-rental-city-notice');
    if (box) { box.hidden = problems.length === 0; box.innerHTML = problems.map(function (t) { return '<li>' + t + '</li>'; }).join(''); }
  }
  shagRentalCity(); document.addEventListener('shag:city', shagRentalCity);
  var cartForm = document.getElementById('shag-cart-form');
  if (cartForm) {
    cartForm.addEventListener('submit', function (e) {
      var over = [];
      cartForm.querySelectorAll('input[name="updates[]"][data-avail]').forEach(function (inp) {
        var avail = parseInt(inp.dataset.avail, 10);
        var want = parseInt(inp.value, 10) || 0;
        if (want > avail) { over.push(inp.dataset.title + ': only ' + avail + ' available'); }
      });
      if (over.length) {
        e.preventDefault();
        alert('Please adjust these quantities:\n\n' + over.join('\n'));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shag-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.shag-testimonials').forEach(function (root) {
    var track = root.querySelector('.shag-testimonials__track');
    if (!track) return; // widget mode renders no carousel markup
    var cards = track.children.length;
    var perPage = window.matchMedia('(max-width: 760px)').matches ? 1 : 3;
    var pages = Math.max(1, Math.ceil(cards / perPage));
    var dotsWrap = root.querySelector('.shag-testimonials__dots');
    var page = 0;

    for (var i = 0; i < pages; i++) {
      var d = document.createElement('button');
      d.dataset.page = i;
      if (i === 0) d.classList.add('is-active');
      d.addEventListener('click', function () { go(parseInt(this.dataset.page, 10)); });
      dotsWrap.appendChild(d);
    }
    function go(n) {
      page = (n + pages) % pages;
      track.style.transform = 'translateX(-' + (page * 100) + '%)';
      dotsWrap.querySelectorAll('button').forEach(function (b, i) {
        b.classList.toggle('is-active', i === page);
      });
    }
    root.querySelector('.shag-testimonials__arrow--prev').addEventListener('click', function () { go(page - 1); });
    root.querySelector('.shag-testimonials__arrow--next').addEventListener('click', function () { go(page + 1); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shag-tiles"] && !Shopify.designMode) return;
  try {
    
  // "Check out Shag's Dallas inventory" on the San Antonio homepage = switch the store to Dallas
  // (live shagsat.com sends visitors to shagcarpetprops.com). Same localStorage key as the header.
  document.querySelectorAll('.shag-tiles [data-shag-set-city]').forEach(function (a) {
    a.addEventListener('click', function () {
      try { localStorage.setItem('shag_city', a.getAttribute('data-shag-set-city')); } catch (e) {}
    });
  });

  } catch(e) { console.error(e); }
})();
})();
